import {
  InfoModule,
  createInfoServices
} from "./chunk-EGIJ26TM.mjs";
import "./chunk-XZSTWKYB.mjs";
export {
  InfoModule,
  createInfoServices
};
